export const user: IUser = {
  email: '',
  emailVerified: false,
  familyName: '',
  givenName: '',
  roles: [],
  username: '',
  nickname: '',
  picture: '',
  sub: '',
  updatedAt: '',

  // sloyd
  credits: 0,
  userId: '',
  name: 'Visitor',
  nextCreditUpdateDate: '',
  nextCreateUpdateDay: 0,
  planId: 'visitor',
  planName: 'Visitor',
};
